import React from 'react';
import {
  Panel,
  RefinementList,
} from 'react-instantsearch-dom';

function CountryFilterPanel() {
  return (
    <div className="card mb-3">
      <div className="card-body">
        <Panel header="Filter by Country">
          <RefinementList
            attribute="country_name"
            showMore={true}
            showMoreLimit={30}
            searchable={true}
          />
        </Panel>
      </div>
    </div>
  );
}

export default CountryFilterPanel;
